import React from 'react';
import { useSelector } from 'react-redux';
import { useCounterPartnersData } from '../../../store/modules/services/searchPartnersApi/hooks';
import { translationsSelector } from '../../../store/modules/translations/selectors';
import { Box, Typography } from '@material-ui/core';

const PartnersCounter: React.FC<Record<string, unknown>> = () => {
	const { count, totalCount } = useCounterPartnersData();
	const { partnersCounterPartnerLabel, partnersCounterInLabel } = useSelector(translationsSelector);
	const message = `${partnersCounterInLabel} ${totalCount}`;

	return totalCount === 0 ? (
		<React.Fragment></React.Fragment>
	) : (
		<Box display="flex" alignItems="center" justifyContent="flex-start" height="100%" width="100%">
			<Typography variant="h4" color="textPrimary" style={{ marginRight: 8 }}>
				<b>
					{count} {partnersCounterPartnerLabel}
				</b>
			</Typography>
			{message && (
				<Typography variant="h4" color="textSecondary">
					<b>{message}</b>
				</Typography>
			)}
		</Box>
	);
};

export default PartnersCounter;
